"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PkpassPreview = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _components = require("./components");

var _color = require("../../utils/color");

var _Theme = require("./Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PkpassPreview = function PkpassPreview(props) {
  var scale = props.scale || 1;
  var c = (0, _color.getInvertColor)(props.pass.backgroundColor);
  var theme = {
    scale: scale,
    foregroundColor: props.pass.foregroundColor,
    labelColor: props.pass.labelColor,
    backgroundColor: props.pass.backgroundColor,
    dragOver: {
      border: "1px solid ".concat(c),
      borderRadius: 5,
      boxShadow: "".concat(c, " 0px 0px 15px"),
      opacity: 0.5
    }
  };
  return /*#__PURE__*/React.createElement(_Theme.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 320 * scale,
      height: 450 * scale,
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement(_components.PkpassContextProvider, {
    pass: props.pass,
    images: props.images,
    scanDisabled: props.scanDisabled,
    onFieldClick: props.onFieldClick,
    onFieldDnD: props.onFieldDnD,
    onImageClick: props.onImageClick,
    onBarcodeClick: props.onBarcodeClick,
    onLogoTextClick: props.onLogoTextClick,
    onBoardingPassIconClick: props.onBoardingPassIconClick
  }, /*#__PURE__*/React.createElement(_components.Mask, null), /*#__PURE__*/React.createElement(_components.DesignerFrontSide, null))));
};

exports.PkpassPreview = PkpassPreview;
PkpassPreview.propTypes = {
  language: _propTypes.default.string,
  scanDisabled: _propTypes.default.bool,
  scale: _propTypes.default.number,
  onFieldClick: _propTypes.default.func,
  onFieldDnD: _propTypes.default.func,
  onImageClick: _propTypes.default.func,
  onBarcodeClick: _propTypes.default.func,
  onLogoTextClick: _propTypes.default.func,
  onBoardingPassIconClick: _propTypes.default.func
};
//# sourceMappingURL=PkpassPreview.js.map